import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { ExitToApp } from '@material-ui/icons';
import { useAuth } from '@agentnet/auth';
import NoAccountFound from './NoAccountFound';
import { AgentNetButton } from '@fluentsms/agentnet-web-components';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.palette.background.default,
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(4),
      maxWidth: '600px',
      textAlign: 'center',
    },
    title: {
      marginBottom: theme.spacing(1),
      color: theme.palette.text.primary,
    },
    description: {
      marginBottom: theme.spacing(3),
      lineHeight: 1.6,
    },
    emailLink: {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
      cursor: 'pointer',
      '&:hover': {
        color: theme.palette.primary.dark,
      },
    },
  }),
);

const AccountNotFound = (): JSX.Element => {
  const classes = useStyles();
  const { logout } = useAuth();

  return (
    <div className={classes.root}>
      <Box className={classes.container}>
        <Box mb={3}>
          <NoAccountFound />
        </Box>
        <Typography variant="h4" className={classes.title}>
          No Accounts Found
        </Typography>
        <Typography variant="body1" color="textSecondary" className={classes.description}>
          We couldn&apos;t find any AgentNet accounts associated with this EagleID.
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Please call the Agency Service Center (ASC) at 866-701-3361 or
        </Typography>
        <Typography variant="body1" color="textSecondary">
          email{' '}
          <a href="mailto:AgencySupport@firstam.com" className={classes.emailLink}>
            AgencySupport@firstam.com
          </a>{' '}
          for assistance.
        </Typography>
        <Box mt={3}>
          <AgentNetButton
            variant="contained"
            color="primary"
            size="medium"
            onClick={logout}
            startIcon={<ExitToApp />}
            data-testid="no-account-found-button-sign-out"
          >
            Sign Out
          </AgentNetButton>
        </Box>
      </Box>
    </div>
  );
};

export default AccountNotFound;
